import React from "react";
import CorporateSocial from "../../components/AboutUs/CorporateSocial/CorporateSocial.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";

const Social: React.FC = () => {
  return (
    <div>
       <MetaComponent
        title="Aptech Ltd | Corporate Social Responsibilty – CSR policies"
        desc="Read all about the latest CSR Policies of Aptech here, an initiative to empower underprivileged youth."
        keywords="Skill development at Aptech, Aptech CSR Policies, Corporate Social Responsibility Aptech Ltd"
      />
      <CorporateSocial />
    </div>
  );
}

export default Social;
